<template>
  
  <div :id="_uid" class="ui large modal" :class="modalSelector">

    <div class="ui header">
      Selecionar Solicitação de Exame
    </div>

    <div class="content modal-content-scrolling">

      <div class="ui form">
        <div class="fields">
          <div class="sixteen wide field">
            <div class="ui icon input" :class="{ loading }">
              <input type="text" placeholder="Pesquisar..." v-model="search" @input="onSearch">
              <i class="search icon"></i>
            </div>
          </div>
        </div>        
      </div>

      <p v-if="requests && requests.length == 0" class="grey text m-t-15 animated fadeIn">
        <i class="info circle icon"></i> Nenhuma solicitação encontrada
      </p>

      <div v-if="requests && requests.length > 0" class="animated fadeIn">
        <p class="grey text m-t-15">
          <i class="clock orange icon"></i> Solicitações aguardando laudo
        </p>
        <div class="ui segment" :class="{ loading }">                
          <table class="ui very basic celled selectable tablet stackable table">
            <thead v-if="$isDesktop">
              <tr>
                <th>Número</th>
                <th>Data</th>
                <th>Veterinário</th>
                <th>Clínica</th>
                <th>Animal</th>
                <th>Tipo do Exame</th>
              </tr>            
            </thead>
            <tbody>
              <tr v-for="(request, index) in requests" :key="index" class="clickable" @click="onSelectRequest(request)">                            
                <td>
                  <strong class="mobile-only">Número: </strong>{{ request.id }}
                </td>
                <td>
                  <strong class="mobile-only">Data: </strong>{{ $formatDate(request.date) }}
                </td>                
                <td>
                  <strong class="mobile-only">Veterinário: </strong>{{ request.vetName }}
                </td>
                <td>
                  <strong class="mobile-only">Clínica: </strong>{{ request.customerName }}
                </td>
                <td>
                  <strong class="mobile-only">Animal: </strong>
                  <span v-html="renderAnimal(request)"></span>
                </td>       
                <td>
                  <strong class="mobile-only">Tipo do Exame: </strong>{{ request.examType.description }}
                </td>         
              </tr>            
            </tbody>
          </table>
        </div>
      </div>            

    </div>

    <div class="actions">
      <button class="ui cancel basic button">
        <i class="times icon"></i> Cancelar
      </button>      
    </div>

  </div>

</template>

<script>

  import debounce from "debounce"
  import ExamRequestService from "@/services/exam-request-service"
  import modalDialog from "@/mixins/modal-dialog"

  export default {
    
    name: "ExamRequestPicker",

    mixins: [modalDialog],

    data() {
      return {
        autofocus: true,
        requests: null,
        search: "",
        service: new ExamRequestService(),
      }
    },

    methods: {      

      onVisible() {
        this.loadRequests()
      },
      
      onSearch: debounce(function() {
        this.loadRequests()
      }, 1000),

      async loadRequests() {

        this.loading = true

        try {
          
          this.requests = await this.service.searchPendingRequests(this.search)
          
        } catch (error) {
          
          this.$errorHandler(error)
        
        } finally {

          this.loading = false
        }
      },

      renderAnimal(request) {
        
        const { animalName, animalSex, raceName, speciesName } = request
        const raceLabel = `<div class="ui small label">${raceName}<div class="detail">Espécie ${speciesName}</div></div>`        
        let sexIcon = animalSex == "male" ? "mars blue icon" : "venus pink icon"

        if (animalSex == "undefined")
          sexIcon = "question circle grey icon"

        return `<i class="${sexIcon}"></i> ${animalName} ${raceLabel}`
      },

      onSelectRequest(request) {
        this.emitEvent = { event: "onPick", data: request }        
        this.hide()
      },
    },
  }

</script>